import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields, Checkbox } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ParamsReportePartidasAclaracion;
export interface State {
    value: Entity;
}

/**
* Componente para editar un Entity
*/
export class ReportePartidasAclaracion extends React.PureComponent<{},State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {
            } as Entity
        };
    }

    errors = () => validation.getErrors(this.rules, this.state.value);
    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x })
    }), this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            FechaDesde: validation.required,
            FechaHasta: validation.required
        };
    }

    onGenerar = async () => {
        const reporte = await resources.RepPartidasAclaracion.Generar(this.state.value);
        await kea.download(reporte, "Reporte partidas en aclaración.xls");
    }

    render() {
        const getField = this.getField;
        const Check = getField(kea.Checkbox);
        const DateTime = getField(kea.DateTime);
        const Sucursal = getField(selectores.Sucursal);
        return (
            <div>
                <kea.Title titulo="Reporte partidas en aclaración" onRegresar={() => history.go("../")} />
                <DateTime field="FechaDesde" label="Fecha desde" />,
                <DateTime field="FechaHasta" label="Fecha hasta" />,
                <Sucursal field="IdSucursal" label="Sucursal" />,
                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Generar reporte" style="success" onClick={this.onGenerar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reportepartidasaclaracion/index.tsx